import instance from "../../api";

const directoryApi = {
    getCities: () => {
        return instance(false).get(`/cities`).then(res => res.data)
    },
    getCategories: () => {
        return instance(false).get(`/categories`).then(res => res.data)
    },
}

export default directoryApi;
